import {
  OutlinedInput, OutlinedInputProps, SxProps, Theme,
} from '@mui/material';
import { CircleAlert } from 'lucide-react';
import type { JSX } from 'react';
import LabelledInputWrapper from './LabelledInputWrapper';

import { corePalette } from '@/themes/colours';

interface IProps extends OutlinedInputProps {
  label?: string;
  helperText?: string;
  helperTextError?: boolean;
  helperTextPlacement?: 'above' | 'below';
  errorMessage?: string;
  wrapperSx?: SxProps<Theme>;
}

export default function CustomOutlinedInput({
  label,
  helperText,
  helperTextError,
  helperTextPlacement,
  error,
  errorMessage,
  multiline,
  fullWidth,
  wrapperSx,
  ...props
}: IProps): JSX.Element {
  return (
    <LabelledInputWrapper
      label={label}
      helperText={helperText}
      helperTextError={helperTextError || Boolean(error)}
      helperTextPlacement={helperTextPlacement}
      errorMessage={errorMessage}
      sx={{
        width: fullWidth ? '100%' : undefined,
        ...wrapperSx,
      }}
    >
      <OutlinedInput
        id="custom-outlined-input"
        multiline={multiline}
        error={error}
        endAdornment={error && !props.endAdornment
          ? (
            <CircleAlert
              fill={corePalette.red150}
              stroke={corePalette.white}
            />
          )
          : props.endAdornment}
        fullWidth={fullWidth}
        {...props}
      />
    </LabelledInputWrapper>
  );
}
